import AccountForm from 'common/pages/account/AccountForm.tsx'

export const AccountFormAgency = (props: any) => <AccountForm {...props} mode={props.mode}/>